import React from "react";

// Iframe-embedded providers: YouTube, Twitch, and generic HTTPS live pages.
// The embeddable `src` is already normalized by resolveVideoSource().

export default function IframePlayer({ src, onHealth, className = "", "data-testid": testId }) {
  return (
    <iframe
      title="Live dealer video"
      src={src}
      allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
      allowFullScreen
      onLoad={() => onHealth && onHealth("live")}
      className={`absolute inset-0 h-full w-full border-0 ${className}`}
      data-testid={testId || "bjv2-iframe"}
    />
  );
}
